
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { FaArrowLeft } from "react-icons/fa"
import { useAppContext } from "../context/AppContext"
import TagForm from "../components/TagForm"
import "./TagFormPage.css"

const EditTagPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { getTag, updateTag } = useAppContext()
  const [tag, setTag] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const tagData = getTag(id)
    if (tagData) {
      setTag(tagData)
    } else {
      navigate("/tags")
    }
    setLoading(false)
  }, [id, getTag, navigate])

  const handleSubmit = (tagData) => {
    updateTag(id, tagData)
    navigate("/tags")
  }

  if (loading) {
    return <div>Carregando...</div>
  }

  return (
    <div className="tag-form-page">
      <div className="page-header">
        <h1 className="page-title">Editar Etiqueta</h1>
        <button className="btn btn-secondary" onClick={() => navigate("/tags")}>
          <FaArrowLeft className="icon-left" /> Voltar
        </button>
      </div>

      <div className="form-container">
        <TagForm initialValues={tag} onSubmit={handleSubmit} />
      </div>
    </div>
  )
}

export default EditTagPage

